import React from "react";

export const AppIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g fill="currentColor">
        <path d="M6 1.5A1.5 1.5 0 0 1 7.5 0h1A1.5 1.5 0 0 1 10 1.5V13H6zM5 4.5A1.5 1.5 0 0 0 3.5 3h-1A1.5 1.5 0 0 0 1 4.5V12a1 1 0 0 0 1 1h3zM15 15a1 1 0 0 0-1-1H2a1 1 0 1 0 0 2h12a1 1 0 0 0 1-1zM15 7.5A1.5 1.5 0 0 0 13.5 6h-1A1.5 1.5 0 0 0 11 7.5V13h3a1 1 0 0 0 1-1z" />
      </g>
    </svg>
  );
};
